module.exports = __webpack_public_path__ + "static/media/simkovic.a5d05c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/simkovic.png
// module id = 486
// module chunks = 0